module.exports = __webpack_public_path__ + "facelifting_5_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/facelifting_5_before.jpg
// module id = 1058
// module chunks = 0